import React from 'react';
import { FormInstance } from 'antd/lib/form';

import FormInput from 'components/FormInput';
import { InputNumber } from 'antd';

import { useQuery } from 'react-query';
import { getAssetattributeByCriteria } from 'services/assetconfig';
import ParListSelect from 'components/ParListSelect';
import UtinaCard from 'components/UtinaCard';

type AssetCatalogAutoDescTableProps = {
  form: FormInstance;
  state?: any;
};

const AssetCatalogAutoDescTable = (props: AssetCatalogAutoDescTableProps) => {
  const { state } = props;

  const { data, refetch, isFetching } = useQuery(
    [
      'getAssetattributeByCriteria',
      {
        attid: 0,
        state,
      },
    ],
    () =>
      getAssetattributeByCriteria({
        attid: 0,
        assetfamily: state.assetfamily?.value ?? '',
        assettype: state.assettype?.value ?? '',
        assetcategory: state.assetcategory?.value ?? '',
      }).then((res) => res.list),
    { enabled: !!state?.assetfamily }
  );

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <UtinaCard
        level={5}
        comcode="technical-characteristics"
        style={{ color: '#000', marginLeft: 30 }}
        lg={24}
        additionalAttribute
      >
        {data && (data[0]?.age === 'DISPLAY' || data[0]?.age === 'MANDATORY') && (
          <FormInput
            rules={[{ required: data[0]?.age === 'MANDATORY' }]}
            col
            xs={24}
            md={6}
            name="age"
          >
            <InputNumber />
          </FormInput>
        )}
        {data &&
          (data[0]?.balersize === 'DISPLAY' ||
            data[0]?.balersize === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.balersize === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="balersize"
            >
              <ParListSelect parcode="BALERSIZE" />
            </FormInput>
          )}
        {data &&
          (data[0]?.separatortype === 'DISPLAY' ||
            data[0]?.separatortype === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.separatortype === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="separatortype"
            >
              <ParListSelect parcode="SEPTYPE" />
            </FormInput>
          )}

        {data &&
          (data[0]?.wheeldrive === 'DISPLAY' ||
            data[0]?.wheeldrive === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.wheeldrive === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="wheeldrive"
            >
              <ParListSelect parcode="WHEELDRIVE" />
            </FormInput>
          )}

        {data &&
          (data[0]?.transmission === 'DISPLAY' ||
            data[0]?.transmission === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.transmission === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="transmission"
            >
              <ParListSelect parcode="TRANSMIS" />
            </FormInput>
          )}

        {data &&
          (data[0]?.wheeltrack === 'DISPLAY' ||
            data[0]?.wheeltrack === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.wheeltrack === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="wheeltrack"
            />
          )}

        {data &&
          (data[0]?.lift === 'DISPLAY' || data[0]?.lift === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.lift === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="lift"
            />
          )}

        {data &&
          (data[0]?.capacity === 'DISPLAY' ||
            data[0]?.capacity === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.capacity === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="capacity"
            />
          )}

        {data &&
          (data[0]?.tankcapacity === 'DISPLAY' ||
            data[0]?.tankcapacity === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.tankcapacity === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="tankcapacity"
            />
          )}

        {data &&
          (data[0]?.nbcampaign === 'DISPLAY' ||
            data[0]?.nbcampaign === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.nbcampaign === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="nbcampaign"
            />
          )}

        {data &&
          (data[0]?.threshinghours === 'DISPLAY' ||
            data[0]?.threshinghours === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.threshinghours === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="threshinghours"
            />
          )}

        {data &&
          (data[0]?.rotorhours === 'DISPLAY' ||
            data[0]?.rotorhours === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.rotorhours === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="rotorhours"
            />
          )}

        {data &&
          (data[0]?.totalbalers === 'DISPLAY' ||
            data[0]?.totalbalers === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.totalbalers === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="totalbalers"
            />
          )}
        {data &&
          (data[0]?.country === 'DISPLAY' ||
            data[0]?.country === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.country === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="country"
            >
              <ParListSelect parcode="COUNTRY" />
            </FormInput>
          )}

        {data &&
          (data[0]?.kwhpower === 'DISPLAY' ||
            data[0]?.kwhpower === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.kwhpower === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="kwhpower"
            >
              <InputNumber />
            </FormInput>
          )}

        {data &&
          (data[0]?.kwhproduction === 'DISPLAY' ||
            data[0]?.kwhproduction === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.kwhproduction === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="kwhproduction"
            >
              <InputNumber />
            </FormInput>
          )}

        {data &&
          (data[0]?.kwhdegradation === 'DISPLAY' ||
            data[0]?.kwhdegradation === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.kwhdegradation === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="kwhdegradation"
            >
              <InputNumber />
            </FormInput>
          )}

        {data &&
          (data[0]?.power === 'DISPLAY' || data[0]?.power === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.power === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="power"
            />
          )}

        {data &&
          (data[0]?.engineno === 'DISPLAY' ||
            data[0]?.engineno === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.engineno === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="engineno"
            />
          )}

        {data &&
          (data[0]?.weight === 'DISPLAY' ||
            data[0]?.weight === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.weight === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="weight"
            />
          )}

        {data &&
          (data[0]?.chassisno === 'DISPLAY' ||
            data[0]?.chassisno === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.chassisno === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="chassisno"
            />
          )}

        {data &&
          (data[0]?.plateno === 'DISPLAY' ||
            data[0]?.plateno === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.plateno === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="plateno"
            />
          )}

        {data &&
          (data[0]?.registrationno === 'DISPLAY' ||
            data[0]?.registrationno === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.registrationno === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="registrationno"
            />
          )}

        {/* {data &&
        (data[0]?.assetmodel === 'DISPLAY' ||
          data[0]?.assetmodel === 'MANDATORY') && (
          <FormInput
            rules={[{ required: data[0]?.assetmodel === 'MANDATORY' }]}
            col
            xs={24}
            md={6}
            name="assetmodel"
          />
        )} */}

        {data &&
          (data[0]?.assetconstructor === 'DISPLAY' ||
            data[0]?.assetconstructor === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.assetconstructor === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="assetconstructor"
            />
          )}

        {data &&
          (data[0]?.serialno === 'DISPLAY' ||
            data[0]?.serialno === 'MANDATORY') && (
            <FormInput
              rules={[{ required: data[0]?.serialno === 'MANDATORY' }]}
              col
              xs={24}
              md={6}
              name="serialno"
            />
          )}
      </UtinaCard>
    </div>
  );
};

export default AssetCatalogAutoDescTable;
